var chunkMapping = {
	"0": [
		4646
	],
	"74": [
		5049
	],
	"150": [
		5125
	],
	"151": [
		5126
	],
	"154": [
		5129
	],
	"155": [
		5130
	],
	"156": [
		5131
	],
	"157": [
		5132
	],
	"158": [
		5133
	],
	"159": [
		5134
	],
	"160": [
		5135
	],
	"161": [
		5136
	],
	"162": [
		5137
	],
	"163": [
		5138
	],
	"164": [
		5139
	],
	"165": [
		5140
	],
	"166": [
		5141
	],
	"167": [
		5142
	],
	"168": [
		5143
	],
	"169": [
		5144
	],
	"170": [
		5145
	]
};
var idToExternalAndNameMapping = {
	"4646": [
		"default",
		"./Containers",
		3796
	],
	"5049": [
		"default",
		"./OrderlessInvoices",
		3796
	],
	"5125": [
		"default",
		"./AsyncEventTracker",
		3796
	],
	"5126": [
		"default",
		"./HostWrapper",
		3796
	],
	"5129": [
		"default",
		"./CheckoutV3",
		3796
	],
	"5130": [
		"default",
		"./CheckoutConfirmation",
		3796
	],
	"5131": [
		"default",
		"./ContactCreditCards",
		3796
	],
	"5132": [
		"default",
		"./AuditDialog",
		3796
	],
	"5133": [
		"default",
		"./InvoiceBlocksOrderDialog",
		3796
	],
	"5134": [
		"default",
		"./InvoiceDialog",
		3796
	],
	"5135": [
		"default",
		"./PaymentDueModal",
		3796
	],
	"5136": [
		"default",
		"./PaymentModal",
		3796
	],
	"5137": [
		"default",
		"./PaymentHistory",
		3796
	],
	"5138": [
		"default",
		"./PaymentConfigurations",
		3796
	],
	"5139": [
		"default",
		"./PaymentPreferences",
		3796
	],
	"5140": [
		"default",
		"./ManagePaymentProcessing",
		3796
	],
	"5141": [
		"default",
		"./MobilePaymentsWrapper",
		3796
	],
	"5142": [
		"default",
		"./Challenge",
		3796
	],
	"5143": [
		"default",
		"./ManagePaymentMethods",
		3796
	],
	"5144": [
		"default",
		"./LightspeedReports",
		3796
	],
	"5145": [
		"default",
		"./ShippingPromotionsListContainer",
		3796
	]
};
var idToRemoteMap = {
	"4646": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5049": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5125": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5126": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5129": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5130": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5131": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5132": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5133": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5134": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5135": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5136": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5137": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5138": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5139": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5140": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5141": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5142": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5143": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5144": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5145": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}